import React, { useEffect, useRef, useState } from "react";
import { inject, observer } from "mobx-react";
import styled from "@emotion/styled";

import { fn_loginRequierd } from "function/FnBodyDetail";
import { fn_managerReset } from "function/FnBodySetting";
import { Button } from "components/ui/Button";

const AuthButton = styled(Button)`
  padding: 14px !important;
`;

const ManagerAuthView = ({ rootStore }) => {
  const { layerStore, viewStore } = rootStore;
  const [loginId, setLoginId] = useState("");
  const [loginPw, setLoginPw] = useState("");
  const idInputRef = useRef(null);

  // 모달이 보이는 상태로 변경되면 포커스 처리
  useEffect(() => {
    if (layerStore.getLayerAuthView) {
      idInputRef.current?.focus();
    }

    // 페이지 이탈 시 입력 값 초기화
    return () => {
      setLoginId("");
      setLoginPw("");
    };
  }, [layerStore.getLayerAuthView]);

  // 입력 값 변경 시 처리
  const handleOnChage = e => {
    const { id, value } = e.target;
    if (id === "loginId") {
      setLoginId(value);
    } else if (id === "loginPw") {
      const onlyNumbers = value.replace(/[^0-9]/g, "");
      setLoginPw(onlyNumbers);
    }
  };

  //엔터키 입력 시 로그인 처리
  const handleOnKeyDown = e => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      handleOnLogin();
    }
  };

  // 닫기 버튼 클릭 시 처리
  const handleOnClose = () => {
    setLoginId("");
    setLoginPw("");
    fn_managerReset(rootStore);
    layerStore.setLayerAuthView(false);
  };

  const handleOnLogin = () => {
    fn_loginRequierd(rootStore, loginId, loginPw);
  };

  return (
    <div className={"layer_comm layer_common_type " + (layerStore.getLayerAuthView ? " layer_open" : "")}>
      <div className="bg"></div>
      <div className="layer_content cs">
        <div className="article_common_type">
          <div className="section_tit_comm2">
            <h1>관리자 인증</h1>
          </div>
          <div className="section_textarea" id="section_textarea_auth">
            <h1 className="auth_tit">포스 로그인 계정을 입력하세요</h1>
            <h2 className="tit">포스 로그인 ID</h2>
            <input
              id="loginId"
              type="text"
              className="num"
              value={loginId}
              onChange={handleOnChage}
              onKeyDown={handleOnKeyDown}
              placeholder="점주(관리자) 권한 ID를 입력하세요"
              ref={idInputRef}
            />
            <h2 className="tit">포스 비밀번호</h2>
            <input
              id="loginPw"
              type="password"
              value={loginPw}
              className="num pw"
              placeholder="숫자만 입력하세요"
              onChange={handleOnChage}
              onKeyDown={handleOnKeyDown}
            />
            <div className="auth_divider"></div>
            <AuthButton onClick={handleOnLogin} variant="black">
              인증하기
            </AuthButton>
            {viewStore.getLoginAuthDetail ? <p className="auth_val">{viewStore.getLoginAuthDetail}</p> : null}
          </div>
          <div className="btn_closes btn_close_comms">
            <button onClick={handleOnClose}>
              <span>닫기</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default inject("rootStore")(observer(ManagerAuthView));
